export type HeroSlide = {
  id: string;
  kicker: string;
  title: string;
  description: string;
  image: string;
  link: string;
  linkLabel: string;
  badge: string;
};

export const heroSlides: HeroSlide[] = [
  {
    id: "slide-1",
    kicker: "焦点作品 · TV动画",
    title: "《星海回响》第二季定档十月，深空航线即将启程",
    description:
      "原班制作团队回归，新机型与全新舞台同步解禁。这一次，他们要讲的不只是出发，还有回望。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cinematic%20key%20visual%20of%20a%20lone%20pilot%20silhouette%20standing%20on%20a%20starship%20deck%20facing%20a%20vast%20orange%20nebula%20and%20deep%20navy%20space%2C%20dramatic%20rim%20light%2C%20epic%20scale%2C%20clean%20minimal%20composition%2C%20high%20detail%20illustration&width=1200&height=675&seq=age-hero-001&orientation=landscape",
    link: "/news/detail/n-001",
    linkLabel: "阅读资讯",
    badge: "最新",
  },
  {
    id: "slide-2",
    kicker: "本期推荐 · TV动画",
    title: "雨巷深处的那家食堂，正在治愈整个夏天",
    description:
      "一间小店，一位话不多的店主，一季来来去去的客人。《雨巷食堂》把治愈拍成了一种生活节奏。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20anime%20illustration%20of%20a%20small%20lantern-lit%20diner%20in%20a%20rainy%20narrow%20alley%20at%20dusk%2C%20glowing%20orange%20windows%20reflecting%20on%20wet%20stone%2C%20deep%20navy%20blue%20rain%2C%20soft%20melancholic%20mood&width=1200&height=675&seq=age-hero-002&orientation=landscape",
    link: "/works/detail/w-003",
    linkLabel: "查看作品",
    badge: "口碑佳作",
  },
  {
    id: "slide-3",
    kicker: "角色专题 · 深度解析",
    title: "凌星野：一个不完美的英雄，如何让人共情",
    description:
      "他不是天生的英雄，甚至长时间在逃避责任。作品用二十四集的时间，把成长拆成可以被看见的细小步伐。",
    image:
      "https://readdy.ai/api/search-image?query=Emotional%20cinematic%20anime%20illustration%20of%20a%20young%20pilot%20looking%20out%20at%20distant%20stars%20through%20a%20large%20ship%20window%2C%20warm%20orange%20backlight%2C%20deep%20navy%20interior%20shadows%2C%20soft%20film%20grain%2C%20quiet%20atmosphere&width=1200&height=675&seq=age-hero-003&orientation=landscape",
    link: "/characters/detail/c-001",
    linkLabel: "阅读解析",
    badge: "专栏",
  },
  {
    id: "slide-4",
    kicker: "国创关注 · TV动画",
    title: "《山海异闻录》定档，水墨与赛璐璐之间的一次尝试",
    description:
      "制作团队用三年时间打磨笔触质感，让古籍里的意象在今天的屏幕上重新呼吸。",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20cinematic%20anime%20illustration%20of%20misty%20mountains%20with%20a%20lone%20traveler%20on%20a%20stone%20path%20and%20a%20vast%20mythical%20winged%20creature%20in%20the%20clouds%2C%20terracotta%20and%20deep%20indigo%20palette%2C%20elegant%20negative%20space&width=1200&height=675&seq=age-hero-004&orientation=landscape",
    link: "/works/detail/w-008",
    linkLabel: "查看作品",
    badge: "国创",
  },
];